import { useParams } from "react-router-dom";
import { LoaderComponent } from "@/shared/components/ui";
import { useCheckPermissions } from "@/shared";
import { PermissionsEnum } from "@/auth/interfaces";
import SavePreventaCorporativa from "../../shared/save_preventa_coperativo/SavePreventaCorporativa";
import { fetchGetByIdPreventasCorporativos } from "@/shared/actions/erp/preventa_corporativo/preventa_corporativo.action";

export default function ViewPreventaCorporativoPage() {

  useCheckPermissions(PermissionsEnum.api_view_preventacoorporativa);

  const { idpreventa } = useParams();

  const { data: dataPreventaCorporativa, isLoading: isLoadingPreventaCorporativa } = fetchGetByIdPreventasCorporativos(idpreventa!)

  if (isLoadingPreventaCorporativa) return <LoaderComponent />

  if (!dataPreventaCorporativa) return null;

  return (
    <SavePreventaCorporativa
      title="Ver Oportunidad Comercial"
      dataProspecto={dataPreventaCorporativa?.data?.prospecto_corporativo_data!}
      dataPreventaCorporativa={dataPreventaCorporativa?.data}
      enableEdit={false}
      isViewOnly={true}
    />
  );

}
